/**
 * Shared state between the staff onboarding launcher and the step it is acting on.
 *
 * The launcher is mounted in the layout while the steps live inside the page, so
 * there is no prop path between them. Rather than have the launcher reach into the
 * DOM, a step announces what it can be asked to do and watches for the request.
 */

import { reactive } from "vue";

export const onboardingDevToolsStore = reactive({
    /** True only while the Perspectives step is on screen and accepting answers. */
    canFillAssessment: false,
    /** Incremented to ask that step to fill every unanswered question and skip to the end. */
    fillAssessmentToken: 0,
});

export function setAssessmentFillAvailable(available: boolean): void {
    onboardingDevToolsStore.canFillAssessment = available;
}

export function requestAssessmentFill(): void {
    onboardingDevToolsStore.fillAssessmentToken += 1;
}
